export enum Rol {
  Admin = 'ADMIN',
  Office = 'OFFICE',
  ClientManager = 'CLIENT_MANAGER',
  DeclarationsManager = 'DECLARATIONS_MANAGER',
  UsersManager = 'USERS_MANAGER',
}
